import { Component, OnInit } from '@angular/core';
import { HelperService } from "../../services/helper/helper.service";
import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../toast/toast.component';
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AddPeersComponent } from "../popups/add-peers/add-peers.component";
import { EditPeersComponent } from "../popups/edit-peers/edit-peers.component";
import { PeersService } from '../../services/peers/peers.service';
import { UserService } from '../../services/user/user.service';
import { BinaService } from '../../services/bina/bina.service';
import { ConfirmDialogComponent } from '../popups/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-peers',
    templateUrl: './peers.component.html',
    styleUrls: ['./peers.component.scss']
})
export class PeersComponent implements OnInit {

    public loading;
    public user;
    public searchFilter;
    public selectedOrder = 'last';

    public atualPage = 'ramais';

    public peers = [];
    public filteredPeers = [];
    public usersCrm = [];
    public binas = [];

    animal: string;
    name: string;

    constructor(
        private helperService: HelperService,
        private snackBar: MatSnackBar,
        private router: Router,
        public dialog: MatDialog,
        public peersService: PeersService,
        public userService: UserService,
        public binaService: BinaService
    ) { }

    ngOnInit() {
        this.init();
    }

    init() {
        this.peers = [];
        this.filteredPeers = [];
        this.usersCrm = [];
        this.binas = [];
        this.loading = true;
        this.helperService.init().then((res) => {
            this.loading = false;
            if (res) {
                this.user = res;
                this.listPeers(() => {
                    this.listUsersCrm(() => {
                        this.getBinas();
                    });
                });
            } else {
                this.snackBar.openFromComponent(ToastComponent, {
                    data: "Assinatura Inválida"
                });
                this.router.navigate(['/notfound']);
            }
        })
    }

    openDialogAdd(): void {
        const dialogRef = this.dialog.open(AddPeersComponent, {
            width: '600px',
            data: {
                usersCrm: this.usersCrm,
                binas: this.binas
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.init();
        });
    }

    openDialogEdit(id): void {
        const dialogRef = this.dialog.open(EditPeersComponent, {
            width: '600px',
            data: {
                usersCrm: this.usersCrm,
                binas: this.binas,
                id: id
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.init();
        });
    }

    openDialogDelete(id): void{
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '600px',
            data: {
                msg: "Tem certeza que deseja deletar esse ramal?",
                id: id
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if(result){
                if(result.confirm){
                    this.deletePeer(result.id)
                }
            }
        });
    }
    

    listPeers(callback) {
        this.loading = true;
        this.peersService.list().subscribe((res) => {
            this.peers = res.peers;
            // this.peers = [];

            callback();
        })
    }

    listUsersCrm(callback) {
        this.userService.listUsersCrm().subscribe((res) => {
            this.usersCrm = res.data;
            this.peers.forEach((peer) => {
                peer.user = this.getUserName(peer.user_crm_id);
            })
            callback();
        })
    }

    deletePeer(id){
        this.peers = [];
        this.filteredPeers = [];
        this.usersCrm = [];
        this.binas = [];
        this.loading = true;
        this.peersService.delete(id).subscribe((res)=>{
            this.loading = false;
            this.snackBar.openFromComponent(ToastComponent, {
                data: res.msg
            });
            this.init();
        })
    }

    getUserName(id) {
        var peerUser = this.usersCrm.find((user) => {
            if (user.id == id) return user;
        })

        if (peerUser) {
            return peerUser.nome
        } else {
            return '--';
        }
    }

    getBinaNumber(id) {
        var bina = this.binas.find((b) => {
            if (b.id == id) return b;
        })

        if (bina) {
            return bina.phone_number
        } else {
            return '--';
        }
    }

    getBinas() {
        this.binaService.list().subscribe((res) => {
            this.binas = res.binas;
            this.peers.forEach((peer) => {
                peer.bina = this.getBinaNumber(peer.bina_id);
            })
            this._filter('');
            this.loading = false;
        })
    }

    _filter(value) {
        this.filteredPeers = this.peers.filter((peer) => {
            var fields = Object.entries(peer);
            if (this.checkFilter(value, fields)) {
                return peer;
            }
            
        })
        this.orderBy();
    }

    checkFilter(value, fields) {
        var found = false;
        fields.forEach((field)=>{
            if(field[1] != null){
                if(field[1].toString().toLowerCase().includes(value.toLowerCase())){
                    found = true;
                }

                if(field[1] == 0){
                    if("Não".toLocaleLowerCase().includes(value.toLowerCase())){
                        found = true;
                    }
                }

                if((field[1] == 1) && (field[0] != 'active')){
                    if("Sim".toLocaleLowerCase().includes(value.toLowerCase())){
                        found = true;
                    }
                }
            }
        })
        return found;
    }

    orderBy(){

        var arrayTemp = JSON.parse(JSON.stringify(this.filteredPeers));

        for(var i=0; i<arrayTemp.length-1; i++){
            for(var j=i+1; j<arrayTemp.length; j++){
                if( this.selectedOrder == 'last' ){
                    if( new Date(arrayTemp[j].created_at)  > new Date(arrayTemp[i].id) ){
                        var auxValue = arrayTemp[i];
                        arrayTemp[i] = arrayTemp[j];
                        arrayTemp[j] = auxValue;
                    }
                }else{
                    if( new Date(arrayTemp[j].id)  < new Date(arrayTemp[i].id) ){
                        var auxValue = arrayTemp[i];
                        arrayTemp[i] = arrayTemp[j];
                        arrayTemp[j] = auxValue;
                    }
                }
            }
        }
        this.filteredPeers = JSON.parse(JSON.stringify(arrayTemp));
    }

}
